import { getKarmaTotal } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { KarmaTotalResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchKarmaTotal(
  days: number | undefined,
  signal?: AbortSignal
): Promise<KarmaTotalResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const params = days != null ? { days } : undefined;
  const response = await getKarmaTotal(params, config);
  return lotusHealthZod.getKarmaTotalResponse.parse(response.data);
}
